import { render, staticRenderFns } from "./usePowerDifference.vue?vue&type=template&id=6bbc8efa&scoped=true&"
import script from "./usePowerDifference.vue?vue&type=script&lang=js&"
export * from "./usePowerDifference.vue?vue&type=script&lang=js&"
import style0 from "./usePowerDifference.vue?vue&type=style&index=0&lang=css&"
import style1 from "./usePowerDifference.vue?vue&type=style&index=1&id=6bbc8efa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bbc8efa",
  null
  
)

export default component.exports